// extracted by mini-css-extract-plugin
export var attribution = "_ag-4";
export var authorName = "_ag-5";
export var quote = "_ag-3";
export var testimonial = "_ag-2";
export var trustedBy = "_ag-0";
export var trustedByLabel = "_ag-1";